<template lang="pug">
.container-fluid
  .d-flex.content-wrapper.col-12.mb-4
    h2.col-3.m-0.p-0 Редактор сценария
    .d-flex.col-4.justify-content-between
      span.btn.btn-outline-success.col-3(v-on:click="previewScript") Предпросмотр
      span#SaveButton.btn.btn-outline-info.col-3(v-on:click='saveScript') Сохранить
      span.btn.btn-outline-secondary.col-3 Отмена
    //- span.btn.btn-info.col-4.p-0(v-on:click='saveElement(selectedElementKey)') ОК
  .mb-3.d-flex.flex-wrap.justify-content-between.content-wrapper.p-2
    #paletteBlock.border-right.col-2(v-show="isEditor")
    #editorBlock.flex-grow-1.editorBlock-wrapper(v-show="isEditor")
    #propertyBlock.border-left.col-3.propertyBlock-wrapper(v-show="isEditor")
      form
        .mb-2
          label.col-12.mb-0.p-0 Название блока
          input.form-control.col-12(type="text" v-model="currentData.text")
        .mb-2
          label.col-12.mb-0.p-0 Содержание
          textarea.form-control.col-12( rows="3" v-model="currentData.repl")
        .mb-5(v-if="selectedElementCategory == 'Conditional' && currentData.key !=0")
          div(v-for="condition in currentData.conditions")
            .d-flex.flex-wrap.justify-content-between
              label.col-11.mb-0.p-0 Условие
              i.fal.fa-times-square.align-self-center(v-on:click='deleteConditional(condition.id)' title='Удалить условие')
            select.form-control.mb-2(v-model='condition.type')
              option(value='0' disabled='' selected='') Тип условия
              option(v-for='conditionType in conditionTypes' v-bind:value='conditionType.id') {{ conditionType.name }}
            .mb-2(v-if="condition.type == '4'")
              select.form-control.col-12.p-0.mb-2(v-model='condition.condData.field')
                option(value='0' disabled='' selected='') Поле
                option(v-for='(field, index) in formData.customFields' v-bind:value='field.name') {{ field.label }}
              .form-check-inline
                input.form-check-input(type="radio" name="radios" id="radios1" value="true" checked v-model="condition.condData.equal")
                label.form-check-label(for="radios1") =
              .form-check-inline
                input.form-check-input(type="radio" name="radios" id="radios2" value="false" v-model="condition.condData.equal")
                label.form-check-label(for="radios2")  &ne;
              input.mb-2.form-control.col-12(type="text" v-model="condition.condData.value")
          span Добавить условие
          i.ml-1.fal.fa-plus-square(v-on:click='addConditional')
        .mb-2.d-flex.justify-content-between
          span.btn.btn-info.col-4.p-0(v-on:click='saveElement(selectedElementKey)') ОК
          span.btn.btn-secondary.col-4.p-0(v-on:click='cancelChanges(selectedElementKey)') Отмена
    .flex-grow-1(v-show="!isEditor")
      //- div(v-for="step in stepList")
      //-   отображение реплики
      //-   div(v-for="button in stepList.buttons")
      //-     отображение кнопок
    .border-left.col-3(v-show="!isEditor")
      .form-group.row.mb-3(v-for="field in formData.customFields" v-bind:key="field.name")
        label.col-xl-3.pt-1.col-form-label(v-bind:for="'fieldID_'+field.name") {{ field.label }}
        .col-xl-9
          template(v-if="field.type == 'text'")
            input.form-control.questionnaire-control(type="text" v-bind:id="'fieldID_'+field.name" v-bind:name="field.name" v-bind:required="field.is_required" v-model="field.value")
          template(v-if="field.type == 'email'")
            input.form-control.questionnaire-control(type="email" v-bind:id="'fieldID_'+field.name" v-bind:name="field.name" v-bind:required="field.is_required" v-model="field.value")
          template(v-if="field.type == 'checkbox'")
            .custom-control.custom-checkbox
              input.custom-control-input.questionnaire-control(type="checkbox" v-bind:id="'fieldID_'+field.name" v-bind:name="field.name" v-bind:required="field.is_required" v-model="field.value" v-bind:for="'fieldID_'+field.id")
              .custom-control-label(for="fieldID_'+field.name")
          template(v-if="field.type == 'select'")
            select.custom-select.questionnaire-control(v-bind:id="'fieldID_'+field.name" v-bind:name="field.name" v-bind:required="field.is_required")
              option(v-for="(val) in field.values" v-bind:key="val.id" v-bind:value="val.id") {{val.name}}
          template(v-if="field.type == 'textarea'")
            textarea.form-control.questionnaire-control(v-bind:id="'fieldID_'+field.name" v-bind:name="field.name" v-model="field.value" rows="3" v-bind:required="field.is_required")
          template(v-if="field.type == 'datalist'")
            input.form-control.questionnaire-control(type="text" v-bind:id="'fieldID_'+field.name" v-bind:name="field.name + field.multiple ? '[]' : ''" v-model="field.value" v-bind:list="'fieldID_'+field.name+'_list'" v-bind:required="field.is_required" v-bind:multiple="field.multiple")
            datalist(v-bind:id="'fieldID_'+field.name+'_list'")
              option(v-for="(val, ind) in field.values" v-bind:key="ind" v-bind:value="val")
</template>
<script>
/* eslint-disable */
// import go from 'gojs'
import { diagramInit } from '../diagram.js'
export default {
  data() {
    return {
      isEditor: true,
      diagram: "",
      selectedElementKey: 0,
      selectedElementText: '',
      selectedElementCategory: '',
      selectedElementIndex: 0,
      scriptData: {},
      stepList: [], // {repl:'',buttons: [{name:'', key: ''},{}]}
      currentData: {
        key: 0,
        repl: '',
        text: '',
        conditions: [
          {
            id: 0,
            type: 0,
            condData: {
            field: '',
            equal: false,
            value: ''
            }
          }
        ]
      },
      conditionTypes: [
        {
          id: 1,
          name: "Рабочее время"
        },
        {
          id: 2,
          name: "Временной диапазон"
        },
        {
          id: 3,
          name: "API-запрос"
        },
        {
          id: 4,
          name: "Значение поля"
        }
      ]
    }
  },
  mounted() {
    this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getScript&project_id=147')
      .then(response => {
        this.scriptData = response.data.data
        this.scriptData.deletedNodes = []
        this.scriptData.deletedLinks = []
        // console.log (this.scriptData)
        var ctx = this
        this.diagram = diagramInit(this.scriptData)
        this.diagram.addDiagramListener('ObjectSingleClicked',function(e){
          var selectedElementKey = e.subject.part.data.key
          console.log(e.subject.part.data)
            if (typeof (selectedElementKey) != "undefined") {
              ctx.ObjectSingleClicked(selectedElementKey)
            }
          })

          this.diagram.addModelChangedListener(function(evt) {
              // ignore unimportant Transaction events
              if (!evt.isTransactionFinished) return;
              var txn = evt.object;  // a Transaction
              if (txn === null) return;

              var deletedNodes = new Map();

              // iterate over all of the actual ChangedEvents of the Transaction
              txn.changes.each(function(e) {
                  // ignore any kind of change other than adding/removing a node
                  if (e.modelChange === "nodeDataArray") {
                      // record node insertions and removals
                       if (e.change === go.ChangedEvent.Remove) {
                         if (typeof (e.oldValue.id) != "undefined") {
                           // console.log("removed node with id: " + e.oldValue.id)
                           deletedNodes.set(e.oldValue.key, e.oldValue)
                           ctx.scriptData.deletedNodes.push(e.oldValue.id)
                           // console.log("deletedNodes " + ctx.scriptData.deletedNodes)
                         }
                       }
                  }
              })
              txn.changes.each(function(e) {
                if (e.change === go.ChangedEvent.Insert) {
                  // console.log(evt.propertyName + " added link between nodes : " + ctx.diagram.findNodeForKey(e.newValue.from) + " and " + ctx.diagram.findNodeForKey(e.newValue.to));
                } else if (e.modelChange === "linkDataArray") {
                      if (e.change === go.ChangedEvent.Remove) {
                        if (typeof (e.oldValue.id) != "undefined") {
                          console.log("removed link " + e.oldValue.id);
                          ctx.scriptData.deletedLinks.push(e.oldValue.id)
                          console.log("deletedLinks " + ctx.scriptData.deletedLinks)
                        }
                      }
                  }
              })
          })

          this.axios.get(this.systemSettings.api_host + '/ajax.php?action=getProject&id=' + this.scriptData.project_id)
            .then(response => {
              // this.formData = response.data.project
              this.formData.customFields = response.data.fields
              this.formData = JSON.parse(JSON.stringify(this.formData))
              // console.log(this.formData)
            })
        }) // end of getScript response
  }, // end of mounted
  computed: {
    systemSettings: function () {
      return this.$store.getters.system_settings
    },
    formData: {
      get: function () {
        return this.$store.getters.formData
      },
      set: function (newValue) {
        this.$store.commit('setFormData', newValue)
      }
    },
    diagramModel () {
      return this.diagram.model
    },
    inputValue: {
      // геттер:
      get: function () {
        return this.selectedElementText
      },
      // сеттер:
      set: function (newValue) {
        this.selectedElementText = newValue
        var filteredSelectedElement = this.scriptData.nodeDataArray.find(item => item.key == this.selectedElementKey)
        filteredSelectedElement.text = this.selectedElementText
        // this.currentData.text = this.selectedElementText
        this.diagram.startTransaction()
        this.diagram.updateAllRelationshipsFromData()
        this.diagram.updateAllTargetBindings()
        this.diagram.commitTransaction("updated")
      }
    },
  },
  methods: {
    ObjectSingleClicked (selectedElementKey) {
      var filteredSelectedElement = this.scriptData.nodeDataArray.find(item => item.key == selectedElementKey)
      // console.log('курлык')
      // console.log(filteredSelectedElement)
      this.selectedElementKey = filteredSelectedElement.key
      this.selectedElementText = filteredSelectedElement.text
      this.currentData.text = filteredSelectedElement.text
      this.currentData.key = selectedElementKey
      var filteredFormDataList = this.scriptData.formDataList.find(item => item.key == selectedElementKey)
      this.selectedElementIndex = this.scriptData.formDataList.indexOf(filteredFormDataList)
      // console.log (this.selectedElementIndex)
      var ctx = this
      if (typeof (filteredFormDataList)  == "undefined") {
        this.selectedElementNodeIndex
        var newFormDataListElement = {key: selectedElementKey, repl: '', text: filteredSelectedElement.text, conditions: []}
        if (filteredSelectedElement.category == 'Conditional') {
          newFormDataListElement.conditions = [{id: 0, type:0, condData: {}}]
          this.currentData.conditions = [{id: 0, type:0, condData: {}}]
        } else {
          this.currentData.conditions = []
        }
        this.scriptData.formDataList.push(newFormDataListElement)
        filteredFormDataList = this.scriptData.formDataList.find(item => item.key == selectedElementKey)
        this.selectedElementIndex = this.scriptData.formDataList.indexOf(filteredFormDataList)
        this.currentData.repl = ''
        // console.log (this.currentData.conditions)
      } else {
        console.log(filteredFormDataList)
        this.currentData.repl = filteredFormDataList.repl
        this.currentData.conditions = JSON.parse(JSON.stringify(filteredFormDataList.conditions))
        // console.log (this.currentData.repl)
      }

      this.selectedElementCategory = filteredSelectedElement.category
      return this.selectedElementText
    },
    // deleteNodes (selectedID) {
    //   var selectedNodeID = this.nodeDataArray.find((item) => item.id === selectedID)
    //   this.scriptData.deletedNodes.push
    // },
    // deleteLinks (selectedID) {
    //   this.scriptData.deletedLinks
    // },
    addConditional () {
      var condition = {type:0, condData: {}}
      this.currentData.conditions.push(condition)
    },
    deleteConditional (condition_id) {
      var condition = {type:0, condData: {}}
      var index = this.currentData.conditions.indexOf(this.currentData.conditions.find((item) => item.id === condition_id))
      this.currentData.conditions.splice(index, 1)
    },
    saveElement (selectedElementKey) {
      this.scriptData.formDataList[this.selectedElementIndex].repl = this.currentData.repl
      this.scriptData.formDataList[this.selectedElementIndex].text = this.currentData.text
      this.inputValue = this.currentData.text
      // console.log(this.scriptData.formDataList[this.selectedElementIndex])
      this.scriptData.formDataList[this.selectedElementIndex].conditions = this.currentData.conditions
    },
    cancelChanges (selectedElementKey) {
      // this.selectedElementText = this.scriptData.nodeDataArray.find(item => item.key == selectedElementKey).text
      this.currentData.text = this.scriptData.nodeDataArray.find(item => item.key == selectedElementKey).text
      // console.log (this.selectedElementText)
      this.currentData.repl = this.scriptData.formDataList.find(item => item.key == selectedElementKey).repl
      // console.log (this.currentData.repl)
      this.currentData.conditions = this.scriptData.formDataList.find(item => item.key == selectedElementKey).conditions
    },
    previewScript () {
      this.isEditor = !this.isEditor
      // elementList = nodes.fileter(cat == start)
      // key стартового элемента
    // printStep (key)
      // foreach (element in elementList) {
      //
      // }
    },
    printStep (key) {
      // linkList = links.fileter(from == element.key)
      //   foreach (link in linkList) {
      //     block = nodes.find(key == link.to)
      //     this.printBlock(block)
      //   }
    },
    // printBlock(block) {
    //   if (block.cat == operator) { print block.repl
          //   printStep (block.key)
          // }
    //   if (block.cat == client) { print block.text}
    //   if (block.cat == condition) {
    //     // проверяем тип условия и запускаем соответствующий обработчик
    //     // и определяем порт yes or no
    //     link = links.find(from == block.key && port == yes)
    //     block2 = nodes.find(key == link.to)
    //     this.printBlock(block2)
    //   }
    // }
    saveScript () {
      var ctx = this
      this.scriptData.nodeDataArray.forEach((element) => {
        if (typeof (element.id) == "undefined") {
          element.id = 0
          element.script_id = ctx.scriptData.id
        }
      })
      this.scriptData.linkDataArray.forEach((element) => {
        if (typeof (element.id) == "undefined") {
          element.id = 0
          element.script_id = ctx.scriptData.id
        }
      })

      var p = {}
      p.scriptData = this.scriptData
      p.action = 'saveScript'
      // console.log(p)
      this.axios.post(this.systemSettings.api_host + '/ajax.php', p)
        //.then(this.saveScript)
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/diagramEditor.vue